'use client';
import {usePathname, useSearchParams} from 'next/navigation';
import * as React from 'react';

import {isAnchorOfCurrentUrl, isHashAnchor} from '@/utils/helpers';
import {useGlobalLoaderContext} from '@/utils/hooks/contextHooks';

import Loader from './base/Loader';

const PageLoader = () => {
  // Convert the url to Absolute URL based on the current window location.
  function findClosestAnchor(element: HTMLElement | null): HTMLAnchorElement | null {
    while (element && element.tagName.toLowerCase() !== 'a') {
      element = element.parentElement;
    }
    return element as HTMLAnchorElement;
  }
  const {isPageLoading, setIsPageLoading} = useGlobalLoaderContext();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  React.useEffect(() => {
    setIsPageLoading(false);
  }, [pathname, searchParams]);

  // React.useEffect(() => {
  //   function handleClick(event: MouseEvent) {
  //     try {
  //       const target = event.target as HTMLElement;
  //       const anchor = findClosestAnchor(target);
  //       const newUrl = anchor?.href.replace('/en/', '/');
  //       if (newUrl) {
  //         const currentUrl = window.location.href;
  //         const isExternalLink = (anchor as HTMLAnchorElement).target === '_blank';
  //         const isSpecialScheme = ['tel:', 'mailto:', 'sms:', 'blob:', 'download:'].some((scheme) => newUrl.startsWith(scheme));
  //         const isAnchor = isAnchorOfCurrentUrl(currentUrl, newUrl);
  //         if (
  //           newUrl === currentUrl ||
  //           isAnchor ||
  //           isExternalLink ||
  //           isSpecialScheme ||
  //           event.ctrlKey ||
  //           event.metaKey ||
  //           isHashAnchor(currentUrl, newUrl)
  //         ) {
  //           setIsPageLoading(false);
  //         } else {
  //            setIsPageLoading(true);
  //         }
  //       }
  //     } catch (err) {
  //       //   console.log('PageLoader error: ', err);
  //       setIsPageLoading(false);
  //     }
  //   }

  //   document.addEventListener('click', handleClick);

  //   return () => {
  //     document.removeEventListener('click', handleClick);
  //   };
  // }, []);
  return isPageLoading ? <Loader /> : <></>;
};
export default PageLoader;
